export enum PUBLISH_PLATFORM {
  DOUYIN = 1,
  KUAISHOU = 2,
  BLIBLI = 3,
  XHS = 4,
  YOUTUBE = 5,
  TIKTOK = 6,
  EMAIL = 7,
}

export enum PUBLISH_STATUS {
  WAIT,
  DOING = 5,
  FINISH = 10,
  CANCEL = 15,
  FAIL = 99,
}

export interface IGetCodeBody {
  platform_type: PUBLISH_PLATFORM // 1=抖音，2=快手，3=B站
}

export interface IPublishListBody {
  id?: string
  page?: number
  page_size?: number
  many?: boolean
  status?: PUBLISH_STATUS // 0=排队中，5=处理中，10=已完成，15=取消， 99=失败
  platform__type?: PUBLISH_PLATFORM
  status__in?: string
}

export interface IPublishBody {
  platform_type: PUBLISH_PLATFORM
  video_url: string
  title: string
  desc: string
  cover_url: string
  tid?: string | string[]
  b_tag?: string
  notify_info: {
    project_id: number
    is_team_source: boolean
    id: number
  }
}

export interface IPublishBodyForeign {
  platform_type: PUBLISH_PLATFORM
  email: string
  generate_record_xihe_task_id: number
}

export interface ISendCodeBody {
  code?: string | number
  platform_type: number
}

export interface IGetAuthRes {
  platform_type: PUBLISH_PLATFORM
  nick_name?: string
  avatar?: string
  auth_url?: string
  res_info?: {
    appKey: string
    nonce: string
    signature: string
    timestamp: number
  }
}

export interface UserPublishItem {
  platform_type: PUBLISH_PLATFORM
  nick_name?: string
  avatar?: string
  auth_url?: string
  name?: string
  icon?: string
}

export interface IPublishResult {
  data: any
}

export interface ISendAuthRes {
  avatar: string
  nick_name: string
  outer_id: string
}

export interface ISendProcess {
  cover_url: string
  desc: string
  processing: number
  id: number
  status: number
  error_reason?: string
  title: string
  platform_id: PUBLISH_PLATFORM
}

export interface IGetProcessRes {
  id: number
  status: PUBLISH_STATUS
  platform_id: PUBLISH_PLATFORM
  platform_type: PUBLISH_PLATFORM
  cover_url: string
  desc: string
  title: string
  video_url: string
  processing: number
  error_reason: string
}
